/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-07-28.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-07-28.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-07-28.mdx';

const metadata = {
  slug: "2020-07-28",
  title: "2020+ Agile-ity",
  author: "Christian Battaglia",
  description: "\"Wisest is he who knows he does not know.\" Thoughts on Agile ceremonies, scrum masters who pretend to code, and the philosophical underpinnings of knowing what you don't know.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-07-28T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["Agile","scrum","AB InBev","Socrates","software process","engineering culture","software engineering","career"],
};

export const Route = createFileRoute('/blog/posts/2020-07-28')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-07-28',
    image: '/og/blog/2020-07-28.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
